import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './contextos/AuthContext';
import { GuardaAdministrador, GuardaAutenticado } from './guardas/Guardas';
import { LayoutApp } from './layouts/LayoutApp';
import { Entrar } from './paginas/Entrar';
import { PrimeiroAcesso } from './paginas/PrimeiroAcesso';
import { Usuarios } from './paginas/Usuarios';
import { Mercadorias } from './paginas/Mercadorias';
import { MercadoriaFicha } from './paginas/MercadoriaFicha';
import { Fornecedores } from './paginas/Fornecedores';
import { Cotacoes } from './paginas/Cotacoes';
import { CotacaoFicha } from './paginas/CotacaoFicha';
import { ComparativoProduto } from './paginas/ComparativoProduto';
import { FornecedorFicha } from './paginas/FornecedorFicha';
import { Painel } from './paginas/Painel';
import { Configuracoes } from './paginas/Configuracoes';
import { Pesquisa } from './paginas/Pesquisa';
import { Oportunidades } from './paginas/Oportunidades';
import { Viabilidade } from './paginas/Viabilidade';
import { EmConstrucao } from './paginas/EmConstrucao';

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/entrar" element={<Entrar />} />
          <Route path="/primeiro-acesso" element={<PrimeiroAcesso />} />

          <Route element={<GuardaAutenticado />}>
            <Route element={<LayoutApp />}>
              <Route index element={<Painel />} />

              <Route path="viabilidade" element={<Viabilidade />} />
              <Route path="oportunidades" element={<Oportunidades />} />
              <Route path="cotacoes" element={<Cotacoes />} />
              <Route path="cotacoes/:id" element={<CotacaoFicha />} />
              <Route path="cotacoes/:id/produto/:produtoId" element={<ComparativoProduto />} />
              <Route path="pesquisa" element={<Pesquisa />} />
              <Route path="mercadorias" element={<Mercadorias />} />
              <Route path="mercadorias/:id" element={<MercadoriaFicha />} />
              <Route path="fornecedores" element={<Fornecedores />} />
              <Route path="fornecedores/:id" element={<FornecedorFicha />} />
              <Route
                path="historico"
                element={
                  <EmConstrucao
                    titulo="Histórico"
                    descricao="Alterações, análises, cotações, mensagens e estimado × realizado."
                    sprint="Sprint S8"
                  />
                }
              />

              <Route element={<GuardaAdministrador />}>
                <Route path="configuracoes" element={<Configuracoes />} />
                <Route path="usuarios" element={<Usuarios />} />
              </Route>

              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
